import type { HTMLAttributes } from 'react';

import { cn } from './cn';

type Props = HTMLAttributes<HTMLDivElement>;

export function Skeleton({ className, ...rest }: Props): JSX.Element {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted/60', className)}
      {...rest}
    />
  );
}
